import { all, call, put, select } from 'redux-saga/effects';
import { get, head, isArray, map } from 'lodash';
import { getRequestEndpoint, prepareRequestData, signAttachments, signDocuments } from '../utils';
import SignService from '../../../../../services/sign';
import { signDocumentsFailure, signDocumentsSuccess } from '../../../redux/sentToGp3/actions';
import { serverRequestSaga } from './serverRequestSaga';
import { getPdfByteArrayService } from 'services/TAPS_API';
import { selectUserInn } from 'modules/App/utils/selectors';

const inventoryDocId = '1184002';

export function* clienSignSaga(action) {
  const {
    docId,
    sendDeclaration: customServerSignRequest,
    responseData,
    attachments,

    //additional parameters
    certificateInfo,
    inn,
    signTogether,
  } = action.payload;

  const versionServerSignRequest = get(customServerSignRequest, 'version', '');

  try {
    const signService = new SignService(certificateInfo); //init sign service
    yield signService.checkCertificate(inn);
    let signedAttachments;

    if (attachments.length && isArray(attachments[0])) {
      signedAttachments = yield all(
        map(attachments, (attachmentsArray) => signAttachments(attachmentsArray, signService)),
      );
    } else {
      signedAttachments = yield signAttachments(attachments, signService);
    }

    const signedXml = yield all(
      map([].concat(responseData), (document) => signDocuments(document, signService)),
    );

    if (signTogether) {
      const inn = yield select(selectUserInn);
      const signedXmlResponse = head(signedXml);
      const byteArray = yield getPdfByteArrayService(signedXmlResponse.pdf, inn);
      signedXmlResponse.pdfSign = yield signService.signCreate(byteArray, {
        fileName: signedXmlResponse.pdf,
      });
    }

    const request = yield call(
      prepareRequestData,
      signedXml.length === 1 && attachments.length && !isArray(attachments[0])
        ? signedXml[0]
        : signedXml,
      signedAttachments,
      null,
      signTogether,
    );

    const inventory = get(request, 'inventory');
    //some endpoint could work only with single document. For them we need to extract document from array.
    const issues = isArray(responseData) ? get(request, 'issues') : get(request, 'issues.[0]');

    yield all(
      map(inventory, (inventoryDoc) => {
        const endpoint = getRequestEndpoint();
        return call(serverRequestSaga, endpoint, inventoryDoc, inventoryDocId);
      }),
    );

    const endpoint = getRequestEndpoint(customServerSignRequest);
    yield call(serverRequestSaga, endpoint, issues, docId, versionServerSignRequest);
  } catch (error) {
    return yield put(signDocumentsFailure(error.message));
  }
  return yield put(signDocumentsSuccess());
}
